import { DependencyList, RefObject, useCallback } from 'react';
import useEvent from './useEvent';

/**
 * @example useEscape((event) => { do something });
 * @param cb The function that should be executed on keydown keyevent.
 * @param target To which esc event to be attached - Defaults to document
 * @param dependencies List of dependencies
 */

const useEscape = (
  cb: (e: KeyboardEvent) => void,
  target: HTMLElement | RefObject<HTMLElement> | Document | null = document,
  dependencies: DependencyList = [],
) => {
  const onKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') cb(e);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cb, ...dependencies],
  );

  useEvent('keydown', onKeydown, { target });
};

export default useEscape;
